import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user;
  logInFailure: boolean = false;

  constructor(private firebaseAuth: AngularFireAuth, private router: Router) {
    // firebaseAuth.authState.subscribe((user) => {
    //   if (user) {
    //     this.user = user;
    //     sessionStorage.setItem('user', JSON.stringify(this.user));
    //     JSON.parse(sessionStorage.getItem('user'));
    //   } else {
    //     sessionStorage.setItem('user', null);
    //     JSON.parse(sessionStorage.getItem('user'));
    //   }
    // });
  }

  get isLoggedIn(): boolean {
    const user = JSON.parse(sessionStorage.getItem('user'));
    return user !== null ? true : false;
  }

  login(email: string, password: string) {
    this.firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then((value) => {
        this.router.navigate(['dashboard']);
        this.user = value;
        sessionStorage.setItem('user', JSON.stringify(this.user));
        JSON.parse(sessionStorage.getItem('user'));
      })
      .catch((error) => (this.logInFailure = true));
  }

  logout() {
    this.firebaseAuth.signOut();
    sessionStorage.setItem('user', null);
    this.router.navigate(['auth']);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isLoggedIn !== true) {
      this.router.navigate(['auth']);
    }
    return true;
  }
}
